export default __webpack_public_path__ + "static/bravemark-prize2@2x-4e85a3b15bf4d9823e8f4c3c7ed2ce62.png";